import { useTranslation } from "react-i18next"

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@f2e/ui/components/base"

import { OrganizationRole, WorkspaceRole, Scope } from "@/types"

export interface RoleSelectProps {
  value: OrganizationRole | WorkspaceRole
  readOnly?: boolean
  mode?: Scope
  onChange: (value: OrganizationRole | WorkspaceRole) => void
}

const RoleSelect = ({ value, readOnly, mode, onChange }: RoleSelectProps) => {
  const { t } = useTranslation()

  const roles: (OrganizationRole | WorkspaceRole)[] =
    mode === Scope.Organization
      ? [
          OrganizationRole.Owner,
          OrganizationRole.Admin,
          OrganizationRole.Member,
        ]
      : [WorkspaceRole.Owner, WorkspaceRole.Admin, WorkspaceRole.Member]

  return (
    <Select value={value} onValueChange={onChange} disabled={readOnly}>
      <SelectTrigger className="w-full h-8">
        <SelectValue placeholder="Select a role" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {roles.map((role) => (
            <SelectItem
              key={role}
              value={role}
              disabled={
                mode === Scope.Organization && role === OrganizationRole.Owner
              }
            >
              <span className="mr-2">{t(`types.role.${role}`)}</span>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export default RoleSelect
